export const MGModalityStep = Object.freeze({
    DASHBOARD: "DASHBOARD",
    DETAIL: "DETAIL",
});